const statusNames = Object.freeze({
    activeInStock: 'AKTIV_LAGER',
    activeNoRefill: 'AKTIV_BRUGES_OP',
    activeRefill: 'AKTIV_HJEMTAGES',
    onRequest: 'FORESP\u{00D8}RGSEL',
    discontinuedWithReplacement: 'UDG\u{00C5}ET_M_ERSTATNING',
    discontinuedNoReplacement: 'UDG\u{00C5}ET_U_ERSTATNING',
    notSoldYet: 'EJ_SOLGT_ENDNU',
})

export const DbConstants = Object.freeze({
    materialBomUsage: Object.freeze({
        Default: '3',
        Maintenance: '4',
        RecommendedItems: '5',
        AlternativeItems: '8',
        Replacement: '9'
    }),

    sparePartPropertyNames: Object.freeze({
        sparePartType: 'RESERVEDEL_TYPE',
        sparePartPackage: 'RESERVEDEL_PAKKE',
        sparePartStatus: 'RESERVEDEL_STATUS',
        sparePartModel: 'RESERVEDEL_MODEL',
        sparePartFunction: 'RESERVEDEL_FUNKTION'
    }),

    sparePartStatusNames: statusNames,

    sparePartStatusesAllowingPurchase: [
        statusNames.activeInStock,
        statusNames.activeNoRefill,
        statusNames.activeRefill,
        statusNames.onRequest
    ] as string[]
})